import { render } from "./BaseSelect.vue?vue&type=template&id=2d71c366&scoped=true&ts=true"
import script from "./BaseSelect.vue?vue&type=script&lang=ts"
export * from "./BaseSelect.vue?vue&type=script&lang=ts"

import "./BaseSelect.vue?vue&type=style&index=0&id=2d71c366&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d71c366"]])

export default __exports__